export const filterImageVariantsForScreenshot = (
    root: HTMLElement,
    isDesktopScreenshot: boolean,
): void => {
    root.querySelectorAll<HTMLImageElement>("img.mobile-image").forEach((mobileImage) => {
        if (isDesktopScreenshot) {
            mobileImage.remove();
            return;
        }

        const desktopImage = mobileImage.previousElementSibling;
        if (desktopImage?.tagName === "IMG" && desktopImage.id === mobileImage.id) {
            desktopImage.remove();
        }
    });
};
